<script setup lang="ts">

</script>

<template>
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 6.83325C12.25 10.9166 7 14.4166 7 14.4166C7 14.4166 1.75 10.9166
      1.75 6.83325C1.75 5.44087 2.30312 4.10551 3.28769 3.12094C4.27226 2.13638
      5.60761 1.58325 7 1.58325C8.39239 1.58325 9.72774 2.13638 10.7123 3.12094C11.6969
      4.10551 12.25 5.44087 12.25 6.83325Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 8.58325C7.9665 8.58325 8.75 7.79975 8.75 6.83325C8.75 5.86675
      7.9665 5.08325 7 5.08325C6.0335 5.08325 5.25 5.86675 5.25 6.83325C5.25 7.79975 6.0335 8.58325 7 8.58325Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>